import React, { lazy } from 'react';
import { SectionWrapper } from './SectionWrapper';
interface Testimonial {
  quote: string;
  name: string;
  role: string;
  photo?: string;
  initials?: string;
}
const testimonials: Testimonial[] = [{
  quote: "La primera vez que usé el paso 1 me sorprendí a mí misma. No grité. Solo dije 'veo que estás muy frustrado' y algo cambió en su cara. No fue magia, pero fue completamente diferente a todo lo que había intentado.",
  name: 'María G.',
  role: 'Mamá de Tomás, 4 años',
  photo: 'https://cdn.magicpatterns.com/uploads/qRsEBEYuKHFCcjACvyUF22/maria_g_resena_1_berrinchea.png'
}, {
  quote: 'Lo leí en el avión de regreso. Esa misma noche mi hijo tuvo una crisis por el baño y en lugar de escalar, bajó en menos de 5 minutos. No lo podía creer.',
  name: 'Carlos R.',
  role: 'Papá de 2 niños, 3 y 6 años',
  photo: 'https://cdn.magicpatterns.com/uploads/vf5q4LqMF7vRJVQohBhSav/resena_2_carlos_r_berrinches.png'
}, {
  quote: 'Lo que más me ayudó fue entender que mi hijo no me desafiaba a propósito. Eso solo ya cambió cómo me siento cuando empieza una crisis.',
  name: 'Valentina M.',
  role: 'Mamá de Sofía, 5 años',
  photo: 'https://cdn.magicpatterns.com/uploads/2ASscBCSqTZ3bZuLhV8txj/resena_3_berriches_valentina_m.png'
}, {
  quote: 'El capítulo 2 me abrió los ojos. Yo era la que escalaba todo sin darme cuenta. Ahora tengo una pausa antes de hablar y eso lo cambia todo.',
  name: 'Andrea L.',
  role: 'Mamá de Lucas, 3 años',
  photo: 'https://cdn.magicpatterns.com/uploads/911257YGGi9b5bd5VQqyoi/resena_4_andrea_L_Berrinches.png'
}];
export function Testimonials() {
  return <SectionWrapper className="bg-cream-dark py-20" constrained={false} data-id="element-293">
      <div className="max-w-6xl mx-auto px-6" data-id="element-294">
        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-295">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-xl shadow-soft border-t-4 border-t-coral flex flex-col" data-id="element-296">
              <div className="text-coral text-lg tracking-widest mb-4" data-id="element-297">
                ⭐⭐⭐⭐⭐
              </div>
              <p className="font-sans text-lg text-ink-mid italic leading-relaxed flex-grow mb-6" data-id="element-298">
                "{t.quote}"
              </p>
              <hr className="border-hairline mb-4" data-id="element-299" />
              <div className="flex items-center gap-4" data-id="element-300">
                {t.photo ? <img src={t.photo} alt={`Foto de ${t.name}`} className="w-14 h-14 rounded-full object-cover shrink-0 border-2 border-coral-light" loading="lazy" data-id="element-301" /> : <div className="w-14 h-14 rounded-full bg-coral-light text-coral-dark font-sans font-bold flex items-center justify-center shrink-0 border-2 border-coral-light" data-id="element-302">
                    {t.initials}
                  </div>}
                <div data-id="element-303">
                  <p className="font-sans font-bold text-sm text-ink" data-id="element-304">
                    {t.name}
                  </p>
                  <p className="font-sans text-sm text-ink-light" data-id="element-305">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-306">
          <p className="font-sans text-xl font-bold text-ink" data-id="element-307">
            ⭐⭐⭐⭐⭐ Más de 847 familias ya están usando el Protocolo Calma 3
            Minutos
          </p>
        </div>
      </div>
    </SectionWrapper>;
}